import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, DatePicker, Drawer, notification, Tooltip, Popconfirm } from 'antd'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import ApplyLeave from '../../components/_utils/leaveapplication';
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'


const { MonthPicker } = DatePicker


@Form.create()
class SalarySlipRequest extends Component {
    state = {
        visible: true
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form, handleSubmit } = this.props
        form.validateFieldsAndScroll((err, valData) => {
            const values = _.clone(valData)
            handleSubmit(values)
        })
    }

    componentDidMount() {

    }

    render() {
        const inputTypes = {
            fields: [
                {
                    label: 'From',
                    key: 'monthFrom',
                    type: 'date',
                    required: true
                },
                {
                    label: 'To',
                    key: 'monthTo',
                    type: 'date',
                    required: true
                }
            ]
        }

        let { form: { getFieldDecorator } } = this.props
        return (
            <React.Fragment>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <div>
                            <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                            <Row style={{ marginTop: '20px' }}>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        Save
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </div>
                    </Form>
                </Card>
            </React.Fragment>
        )
    }
}


@Form.create()
class SalarySlip extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        month: moment(),
        defaultPageSize: 20,
        activityArr: [],
        oldLeaves: [],
        showResignationForm: false,
        sandwichLeaves: 0,
        casualLeaves: 0,
        leavesWithoutPay: 0,
        leavesWithoutNotice: 0,
        record: [],
        showHandoverForm: false,
        showSalarySlipRequest: false
    }



    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }


    constructor(props) {
        super(props)
        this.table = React.createRef()
    }


    handleSalarySlipRequest = () => {
        this.setState({ showSalarySlipRequest: true })
    }



    apiRequest = params => {
        return new Promise(async (resolve) => {
            let response = await Request.getUserSalarySlipRequests(params);
            this.setState({ count: response.total })
            resolve(response)
        })
    }


    reload = () => {
        this.table.current.reload()
    }

    componentDidMount() {

    }

    render() {
        const { defaultPageSize, showSalarySlipRequest, count } = this.state
        const columns = [
            {
                title: 'From',
                key: 'monthFrom',
                render: (val, record) => (
                    <div>
                        {moment(record.monthFrom).format("DD-MM-YYYY")}
                    </div>
                )
            },
            {
                title: 'To',
                key: 'monthTo',
                render: (val, record) => (
                    <div>
                        {moment(record.monthTo).format("DD-MM-YYYY")}
                    </div>
                )
            },
            {
                title: 'Created/Updated By',
                key: 'updatedByUser.name',
                render: (text, record) => {
                    if (!record.updatedByUser) {
                        return (
                            <div>{record.createdByUser.name}</div>
                        )
                    } else {
                        return (
                            <div>{record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title: 'Status',
                key: 'status',
                render: (text, record) => {
                    if (text === 'Approved') {
                        return (
                            <div style={{ background: 'green', color: 'white' }}>{text}</div>
                        )
                    } else if (text === 'Disapproved') {
                        return (
                            <div style={{ background: 'red', color: 'white' }}>{text}</div>
                        )
                    } else {
                        return (
                            <div style={{ background: 'yellow' }}>{text}</div>
                        )
                    }
                }
            }
        ]


        return (
            <PageHeaderWrapper title={`Salary Slips:- ${count}`}>
                <Card bordered={true}>
                    <Row>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Button onClick={this.handleSalarySlipRequest}>Request For Salary Slip</Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
                <Drawer
                    title="Request Salary Slip"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            showSalarySlipRequest: false
                        })
                    }}
                    visible={showSalarySlipRequest}
                    width={600}>
                    <SalarySlipRequest loading={this.props.loading} handleSubmit={async values => {
                        let response = await Request.addSalarySlipRequest(values)
                        if (!response.error) {
                            notification.success({
                                message: response.message
                            })
                            this.setState({ showSalarySlipRequest: false })
                            this.reload()
                        } else {
                            notification.error({
                                message: response.message
                            })
                            this.setState({ showSalarySlipRequest: false })
                        }
                    }} />
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalarySlip)
